import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { exportToExcel, getPrescriptionReports } from "../../api/prescriptionReport";
import Card from "../../components/Cards/Card";
import Filters from "../../components/PrescriptionReports/Filters";
import PrescriptionsTable from "../../components/PrescriptionReports/PrescriptionsTable";
import { useMasterData } from "../Database/Hooks";

// Filtros iniciales
const initialFilters = {
  StartDate: "",
  EndDate: "",
  HealthInsurance: null,
  MedicalRecordNumber: null,
  Practitioner: null,
  pagination: { page: 1, sizePerPage: 10 },
  sort: { sortField: "", sortOrder: "" },
};

export const PrescriptionReport = () => {
  const [filters, setFilters] = useState(initialFilters);
  const [appliedFilters, setAppliedFilters] = useState(initialFilters);
  const [data, setData] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [loading, setLoading] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [hasAppliedFilters, setHasAppliedFilters] = useState(false);
  const [actionType, setActionType] = useState("");

  const [masterData, isLoadingMasterdata] = useMasterData();

  useEffect(() => {
    // Método para cargar los datos desde la API
    const loadData = async () => {
      setLoading(true);
      try {
        const response = await getPrescriptionReports(appliedFilters);
        setData(response.data);
        setTotalSize(response.totalCount);
      } catch (error) {
        console.log("[Frontend] Error al cargar los reportes:", error.message);
      } finally {
        setLoading(false);
        setButtonLoading(false);
      }
    };

    loadData();

  }, [appliedFilters]);

  const handleChange = (name, value) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
      pagination: { page: 1, sizePerPage: prev.pagination.sizePerPage },
    }));
  };

  //Paginación
  const handleTableChange = (_, { page, sizePerPage }) => {
    setFilters((prev) => ({
      ...prev,
      pagination: { page, sizePerPage }
    }));
    setAppliedFilters((prev) => ({
      ...prev,
      pagination: { page, sizePerPage }
    }));
  };

  // Manejo de la exportación a Excel
  const handleExport = async () => {
    try {
      await exportToExcel(appliedFilters);
    } catch (error) {
      console.error("[Frontend] Error al exportar a Excel:", error.message);
    }
  };

  // Aplicar filtros
  const handleApply = () => {
    setActionType("apply");
    setData([]);
    setLoading(true);
    setButtonLoading(true);
    setAppliedFilters(filters);
    setHasAppliedFilters(true);
  };

  const handleClear = () => {
    setActionType("clear");
    const reset = {
      ...initialFilters,
      pagination: { page: 1, sizePerPage: filters.pagination.sizePerPage }
    };

    setData([]);
    setLoading(true);
    setButtonLoading(true);
    setFilters(reset);
    setAppliedFilters(reset);
    setResetKey(prev => prev + 1);
    setHasAppliedFilters(false);
  };

  const filtersChanged = JSON.stringify(filters) !== JSON.stringify(appliedFilters);

  return (
    <div className="prescription-reports-view">
      <Card
        header={
          <Row>
            <Col md={12}>
              <Filters
                masterData={masterData}
                filters={filters}
                onChange={handleChange}
                onApply={handleApply}
                onClear={handleClear}
                filtersChanged={filtersChanged}
                hasAppliedFilters={hasAppliedFilters}
                onExport={handleExport}
                resetKey={resetKey}
                buttonLoading={buttonLoading || isLoadingMasterdata}
                actionType={actionType}
              />
            </Col>
          </Row>
        }
        content={
          <PrescriptionsTable
            data={data}
            filters={filters}
            totalSize={totalSize}
            loading={loading}
            onTableChange={handleTableChange}
          />
        }
      />
    </div>
  );
};

export default PrescriptionReport;
